import qs from 'qs';
import { history } from '../../store/history';

export const setQuery = (queryParams: { [x: string]: unknown }) => {
    history.replace({
        search: qs.stringify(queryParams),
    });
};
